import { render, staticRenderFns } from "./Chem1301Lab3Discussion1.vue?vue&type=template&id=ee7e97a8&scoped=true&"
import script from "./Chem1301Lab3Discussion1.vue?vue&type=script&lang=ts&"
export * from "./Chem1301Lab3Discussion1.vue?vue&type=script&lang=ts&"
import style0 from "./Chem1301Lab3Discussion1.vue?vue&type=style&index=0&id=ee7e97a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7e97a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VContainer,VForm,VRow,VTextarea})
